<template>
  <div id="app">
    <nav-bar />

    <main class="container">
      <transition enter-active-class="animated fade-in" mode="out-in" leave-active-class="animated fade-out">
        <router-view />
      </transition>
    </main>

    <the-footer />
  </div>
</template>

<script>
import NavBar from '@/components/general/NavBar';
import TheFooter from '@/components/general/TheFooter';

export default {
  name: 'App',
  components: { NavBar, TheFooter, },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.animated {
  -webkit-animation-duration: 0.2s;
  animation-duration: 0.2s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@keyframes fade-in {
  from {
    -webkit-transition: opacity 0.2s ease-in-out;
    -moz-transition: opacity 0.2s ease-in-out;
    -ms-transition: opacity 0.2s ease-in-out;
    -o-transition: opacity 0.2s ease-in-out;
    opacity: 0;
    visibility: visible;
  }

  to {
    opacity: 1;
  }
}

@keyframes fade-out {
  from {
    -webkit-transition: opacity 0.2s ease-in-out;
    -moz-transition: opacity 0.2s ease-in-out;
    -ms-transition: opacity 0.2s ease-in-out;
    -o-transition: opacity 0.2s ease-in-out;
    opacity: 1;
  }

  to {
    opacity: 0;
    visibility: visible;
  }
}

.fade-out {
  animation-name: fade-out;
}

.fade-in {
  animation-name: fade-in;
}

.fade-in-enter-active {
  transition: opacity 0.8s;
}

.fade-in-enter {
  opacity: 0;
}

.loading-section {
  position: relative;
  height: 50px;
}
</style>
